import * as z from "zod";
import { Icon } from "./Icon";
import { Image } from "./Image";
import { Markdown } from "./Markdown";
export const ImageInputOutputExpected = z.object({
    type: z.literal("image_input_output_expected"),
    value: z.object({
        description: Markdown,
        input: Image,
        results: z
            .object({
            output: Image,
            expected: Image,
            mark: Icon,
        })
            .array(),
    }),
});
